// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__nm5T_","heading":"styles_heading__N4Tcb","text":"styles_text___VhC6","button":"styles_button__0VKmd","image_container":"styles_image_container__GtXf8"};